import { render } from "./PaymentsApprovalHistory.vue?vue&type=template&id=e2f48bfc"
import script from "./PaymentsApprovalHistory.vue?vue&type=script&lang=js"
export * from "./PaymentsApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__